import { Component, inject, input } from '@angular/core';
import { ProductCardV2Component } from '../../../shared/product-card-v2/product-card-v2.component';
import { LocalStorageService } from '../../../shared/local-storage.service';
import { LOCALSTORAGE_KEYS } from '../../../shared/constants/databases';
import { Location } from '@angular/common';
import { SignUpProducts } from '../signup.types';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-welcome',
  imports: [
    ProductCardV2Component
  ],
  templateUrl: './welcome.component.html',
  styleUrl: './welcome.component.scss'
})
export class WelcomeComponent {

  //#region Services

  #localStorageService = inject(LocalStorageService);

  #location = inject(Location);

  //#endregion

  //#region I/O

  products = input.required<Map<number | string, SignUpProducts>>();

  //#endregion

  //#region Method

  email = environment.config.contactEmail;

  finish() {
    this.#location.replaceState('/shop');
    window.location.reload();
  }

  //#endregion
}
